var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsvIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "55px",
    height: "55px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9,14.8V0.5H9.8C8.4,0.5,7.2,1.6,7.2,3v49c0,1.4,1.1,2.5,2.5,2.5h35.5c1.4,0,2.5-1.1,2.5-2.5V17.4H33.4 C32,17.4,30.9,16.2,30.9,14.8z M20.7,30c0,0.5-0.4,0.8-0.8,0.8h-0.8c-0.9,0-1.7,0.8-1.7,1.7v3.4c0,0.9,0.8,1.7,1.7,1.7h0.8 c0.5,0,0.8,0.4,0.8,0.8v1.7c0,0.5-0.4,0.8-0.8,0.8h-0.8c-2.8,0-5.1-2.3-5.1-5.1v-3.4c0-2.8,2.3-5.1,5.1-5.1h0.8 c0.5,0,0.8,0.4,0.8,0.8V30z M25.4,41h-1.3c-0.5,0-0.8-0.4-0.8-0.8v-1.7c0-0.5,0.4-0.8,0.8-0.8h1.3c0.6,0,1.1-0.4,1.1-0.7 c0-0.1-0.1-0.3-0.2-0.4l-2.3-2c-0.9-0.8-1.4-1.8-1.4-3c0-2.2,2-4.1,4.5-4.1h1.3c0.5,0,0.8,0.4,0.8,0.8V30c0,0.5-0.4,0.8-0.8,0.8H27 c-0.6,0-1.1,0.4-1.1,0.7c0,0.1,0.1,0.3,0.2,0.4l2.3,2c0.9,0.8,1.4,1.8,1.4,3C29.9,39.2,27.9,41,25.4,41L25.4,41z M34.3,28.3v2.2 c0,2.1,0.6,4.2,1.7,6c1.1-1.8,1.7-3.9,1.7-6v-2.2c0-0.5,0.4-0.8,0.8-0.8h1.7c0.5,0,0.8,0.4,0.8,0.8v2.2c0,3.7-1.4,7.3-3.8,9.9 c-0.3,0.3-0.8,0.5-1.2,0.5s-0.9-0.2-1.2-0.5c-2.5-2.7-3.8-6.2-3.8-9.9v-2.2c0-0.5,0.4-0.8,0.8-0.8h1.7 C33.9,27.5,34.3,27.9,34.3,28.3z M47,11.6L36.7,1.2c-0.5-0.5-1.1-0.7-1.8-0.7h-0.6V14h13.5v-0.6C47.8,12.7,47.5,12,47,11.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvIcon);
export default __webpack_public_path__ + "static/media/csv_icon.49ad6d8d2a504994f61abe4187ed1578.svg";
export { ForwardRef as ReactComponent };